import { PROJECT_FILES_TAG, PROJECT_TAG, PROJECTS_LIST_TAG } from '@/api/constants';
import { api } from '@/api/core';
import { deleteMockProjectFiles } from './mockProjectFiles';
import { mockDelay, readMockProjectError } from './mockUtils';

export interface DeleteProjectFilesRequest {
  projectId: string;
  fileIds: string[];
}

const MOCK_RESPONSE_DELAY_MS = 600;

const deleteProjectFilesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    deleteProjectFiles: builder.mutation<void, DeleteProjectFilesRequest>({
      // The backend has no endpoint to delete project files yet: edit the mock list (see mockProjectFiles.ts).
      queryFn: async ({ projectId, fileIds }) => {
        await mockDelay(MOCK_RESPONSE_DELAY_MS);
        const mockError = readMockProjectError();
        if (mockError) return { error: mockError };
        return deleteMockProjectFiles(projectId, fileIds)
          ? { data: undefined }
          : { error: { status: 404, data: 'File not found' } };
      },
      invalidatesTags: (_result, error, { projectId }) =>
        error
          ? []
          : [
              { type: PROJECT_FILES_TAG, id: projectId },
              { type: PROJECT_TAG, id: projectId },
              { type: PROJECTS_LIST_TAG },
            ],
    }),
  }),
});

export const { useDeleteProjectFilesMutation } = deleteProjectFilesApi;
